import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Api from '../../../util/api';
import t from '../../../util/translation/translation';

// The select options of the event form (categories, company levels and
// groups, tiers), loaded the same way as EventsFormPage does
const useEventFormOptions = () => {
  const [options, setOptions] = useState({
    eventCategories: [],
    eventLevels: [],
    eventGroups: [],
    eventTiers: [],
    loaded: false,
  });

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const [resCategories, resLevels, resGroups, resTiers] =
          await Promise.all([
            Api.events.getEventCategories(),
            Api.club.getLevels(),
            Api.club.getGroups(),
            Api.tiers.allTiers(),
          ]);
        if (cancelled) return;
        setOptions({
          eventCategories: resCategories.data.map(
            ({ id, title, maxAttendees }) => ({
              value: id,
              label: title,
              maximum: maxAttendees,
            })
          ),
          eventLevels: resLevels.map(({ id, value }) => ({
            value: id,
            label: value,
          })),
          eventGroups: resGroups.map(({ id, value }) => ({
            value: id,
            label: value,
          })),
          eventTiers: resTiers.data.map((tier) => ({
            label: tier.name,
            value: tier.id,
          })),
          loaded: true,
        });
      } catch (err) {
        if (cancelled) return;
        toast.error(err || t('shared.somethingWentWrong'));
        setOptions((existing) => ({ ...existing, loaded: true }));
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return options;
};

export default useEventFormOptions;
